import React from 'react';
import classNames from 'classnames';
import mainStyles from '../../../styles.module.scss';

export const SyncWithSalesForceComponent = ({ isSyncingWithSalesForce, handleSyncWithSalesForce, disabled }) => {
  return (
    <button
      id="syncWithSalesForceButton"
      className={classNames(mainStyles.secondaryBtn, {
        [mainStyles.actionButton]: true,
        [mainStyles.regularBtn]: true
      })}
      onClick={handleSyncWithSalesForce}
      disabled={disabled}
    >
      {isSyncingWithSalesForce ? 'SYNCING...' : 'SYNC WITH SALESFORCE'}
    </button>
  );
};
